var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUdacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29 .5 1 .5v13c0 5.551887-2.8897 8.695692-5.995216 10.099885l.004616.000115-7.620963 4.388562c-.05877.03456-.11776.068527-.176957.101902l-.08642.049764.001806-.00254c-1.643976.908207-3.442184 1.362312-5.126866 1.362312-5 0-11-4-11-12v-12l2 1v11c0 8 6 10 9 10 1.858706 0 4.86901-.76773 6.89043-3.254517-3.708704-.872847-7.89043-4.06678-7.89043-10.745483v-11.8l-8 4.8-2-1 10-6 1 .5 1 .5v13c0 6.939958 4.515283 8.612086 7.017542 8.933368.608244-1.311778.982458-2.935466.982458-4.933368v-13l2 1v12c0 1.852645-.321777 3.49077-.878395 4.91438 2.526618-.365163 6.878395-2.101236 6.878395-8.91438v-11.75l-6 3.75-2-1 8-5z",
    fill: "#02b3e4",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdacity);
export default __webpack_public_path__ + "static/media/Udacity.a61fafd0.svg";
export { ForwardRef as ReactComponent };